
































import {Component, Prop, Vue} from "vue-property-decorator";
import StoriesViewer from '~/stories_widget/components/Stories/StoriesViewer/StoriesViewer';
import {PropType} from "vue";
import SharePanel from "~/stories_widget/components/SharePanel/SharePanel.vue";
import {NarrativeData, SendApiRequestConfig} from "~/stories_widget/models/NarrativeData";
import isObject from "lodash/isObject";
import isBoolean from "lodash/isBoolean";
import {needSession} from "~/stories_widget/util/env";

export type GameData = {
    gameFile: string;
    coverFile: string;
    gameConfig: string;
    addResources: string;
};

@Component({
    name: "GameReader",
    components: {SharePanel},
})
export default class GameReader extends Vue {

    @Prop({type: Object as PropType<Nullable<GameData>>}) gameData!: Nullable<GameData>;
    @Prop({type: Boolean}) desktopMode!: boolean;

    isLoading: boolean = true;
    isGameInited: boolean = false;
    iframeElement!: HTMLIFrameElement;
    shareLink: Nullable<string> = null;
    sharePanelOpen = false;
    showClose = true;

    get coverFile(): Nullable<string> {
        if (this.gameData !== null) {
            return this.gameData.coverFile;
        }
        return null;
    }

    get gameFile(): Nullable<string> {
        if (this.gameData && this.gameData.gameFile) {
            // replace for https://games.test.inappstory.com/fifteen-puzzle/v1/build/fifteen-puzzle-game_v1.zip

            // https://stackoverflow.com/questions/51568821/works-in-chrome-but-breaks-in-safari-invalid-regular-expression-invalid-group
            // Looks like Safari doesn't support lookbehind yet https://caniuse.com/js-regexp-lookbehind
            // return this.gameData.gameFile.replace(/(?<=build\/).+\.zip$/, 'index.html');
            return this.gameData.gameFile.replace(/(build\/).+\.zip$/, 'build/index.html');

        }
        return null;
    }

    get gameFileOrigin(): Nullable<string> {
        if (this.gameFile !== null) {
            return new URL(this.gameFile).origin;
        }
        return null;
    }

    get gameConfig() {
        const config = this.gameData?.gameConfig;
        const resources = this.gameData?.addResources;

        if (config && resources) {
            if (Array.isArray(resources) && resources.length > 0) {
                for (let key of Object.keys(config)) {
                    if (config.hasOwnProperty(key)) {
                        for (let i = 0; i < resources.length; i++) {
                            if (resources[i]['key'] === (<any>config)[key]) {
                                (<any>config)[key] = resources[i]['url'];
                            }
                        }
                    }
                }
            }
        }
        return config;
    }

    created() {
        window.addEventListener("message", this.messageListener, false);
    }

    destroyed() {
        window.removeEventListener("message", this.messageListener);
    }

    messageListener(event: MessageEvent) {
        if (event.origin !== this.gameFileOrigin)
            return;

        const data = event.data;
        if (Array.isArray(data)) {
            switch (data[0]) {
                case "gameLoaded": {
                    this.isLoading = false;
                    this.isGameInited = true;

                    if (data[1] !== undefined) {
                        let payload = {
                            showClose: true,
                            backGesture: false
                        };
                        try {
                            // {showClose: false, backGesture: false}
                            //@ts-ignore
                            payload = JSON.parse(data[1]);
                            if (isObject(payload) && "showClose" in payload && isBoolean(payload.showClose)) {
                                this.showClose = payload.showClose;
                            }
                        } catch (e) {
                            console.error(e);
                        }

                    }

                }
                    break;
                case "gameComplete": {
                    let payload = undefined;
                    try {
                        if (data[1] !== undefined) {
                            payload = data[1];
                            // payload = JSON.parse(data[1]);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    this._closeGameReader(payload);
                }
                    break;
                case "share": {
                    let id = undefined;
                    let config = undefined;
                    try {
                        if (data[1] !== undefined) {
                            id = data[1];
                        }
                        if (data[2] !== undefined) {
                            config = data[2];
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    this._shareAction(id, config);
                }
                    break;
                case "sendApiRequest": {
                    try {
                        if (data[1] !== undefined) {
                            let payload = data[1];
                            // if (needSession()) {
                                NarrativeData.sendApiRequestPromise(payload, (cb: string, plainData: string) => this.sendEventToGame('cb', {cb, plainData}));
                            // }

                            // payload = JSON.parse(data[1]);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                } break;
                case "storySetLocalData": {
                    try {
                        if (data[1] !== undefined) {
                            try {
                                let payload = JSON.parse(data[1]);
                                // if (needSession()) {
                                /**
                                 *                 storyId: $gameConfig.getState().storyId,
                                 data: keyValue,
                                 sendToServer: sendToServer
                                 */
                                if (isObject(payload)) {
                                    //@ts-ignore
                                    const {storyId, data, sendToServer} = payload;

                                    sessionStorage.setItem(`narrative_${storyId}_data`, JSON.stringify(data));

                                    if (sendToServer === true) {
                                        if (needSession()) {
                                            NarrativeData.sentData(storyId, {data: JSON.stringify(data)});
                                        }
                                    }
                                }

                            } catch (e) {
                                console.error(e);
                            }
                        }
                    } catch (e) {
                        console.error(e);
                    }
                } break;
                case "storyGetLocalData": {
                    //       // NarrativeData.sendApiRequestPromise(payload, (cb: string, plainData: string) => this.sendEventToGame('cb', {cb, plainData}));
                    try {
                        if (data[1] !== undefined) {
                            try {
                                let payload = JSON.parse(data[1]);
                                // if (needSession()) {
                                /**
                                 id,
                                 storyId: $gameConfig.getState().storyId,
                                 callback: "storyGetLocalDataCb"
                                 */
                                if (isObject(payload)) {
                                    //@ts-ignore
                                    const {id, storyId, callback} = payload;

                                    if ((<any>window).__activeNarrativeId !== undefined) {
                                        let localData = sessionStorage.getItem(`narrative_${storyId}_data`); // user_id (реализуется через сессию)
                                        this.sendEventToGame('cb', {cb: callback, arguments: JSON.stringify([id, localData])});
                                    }
                                    this.sendEventToGame('cb', {cb: callback, arguments: JSON.stringify([id, ""])});
                                }

                            } catch (e) {
                                console.error(e);
                            }
                        }
                    } catch (e) {
                        console.error(e);
                    }
                } break;

            }


        }

    }

    get gameReaderWindow(): Nullable<Window> {
        if (this.iframeElement) {
            if (this.iframeElement.contentWindow !== null) {
                return this.iframeElement.contentWindow;
            }
        }
        return null;
    }

    sendEventToGame(name: string, data?: any): boolean {
        if (!this.gameReaderWindow) {
            return false;
        }
        if (!this.gameFileOrigin) {
            return false;
        }
        this.gameReaderWindow.postMessage([name, data], this.gameFileOrigin);
        return true;
    }


    iframeOnLoad(el: Event): void {
        this.iframeElement = el.target as HTMLIFrameElement;
        this.sendEventToGame('initGame', this.gameConfig);
    }

    updateIframeContent(content: string): void {
        if (this.$refs['gameReaderIframe'] !== null && this.$refs['gameReaderIframe'] !== undefined) {
            const iframeElement = (<HTMLFrameElement>this.$refs['gameReaderIframe']);
            if (iframeElement.contentWindow !== null && iframeElement.contentWindow.document !== null) {
                iframeElement.contentWindow.document.write(content);
                iframeElement.contentWindow.document.close();
            }
        }
    }

    closeGameReader(): void {
        if (this.isGameInited) {
            this.sendEventToGame('closeGameReader');
        } else {
            this._closeGameReader();
        }
    }

    _closeGameReader(data?: object): void {
        const iframeElement = (<HTMLFrameElement>this.$refs['gameReaderIframe']);
        if (iframeElement.contentWindow !== null) {
            iframeElement.src = 'about:blank';
        }

        (<StoriesViewer>this.$parent).closeGameReader();
        (<StoriesViewer>this.$parent).resumeAndEnableReaderUIForGameReader();
        this.isGameInited = false;

        // pass ev to story
        if ((<any>window)._narrative_game) {
            (<any>window)._narrative_game.complete(data);
        }

    }

    shareId: string = '';
    _shareAction(id: string, config: { url: string }) {
        this.shareId = id;
        const sharePath = config?.url;

        const openSharePanel = () => {
            this.shareLink = sharePath;
            this.sharePanelOpen = true;
        }

        if (this.desktopMode || !(<any>navigator).share) {
            openSharePanel();
        } else {
            try {

                if ((<any>navigator).share) {
                    (<any>navigator).share({
                        url: sharePath,
                    })
                        .then(() => {
                            this._shareComplete(id, true);
                        })
                        .catch((error: any) => {
                                this._shareComplete(id, false);
                            }
                        );
                }
            } catch (e) {
                // navigator.share есть но не срабатывает на win 7 например
                openSharePanel();
            }
        }

    }

    _shareComplete(id: string, isSuccess: boolean) {
        this.sendEventToGame('shareComplete', {id, isSuccess});
    }

    sharePanelComplete(isSuccess: boolean) {
        this._shareComplete(this.shareId, isSuccess);
    }


}

